export const enum UserReducerActionType {
  UPDATE_USER_INFO = 'UPDATE_USER_INFO',
  CLEAR_USER_INFO = 'CLEAR_USER_INFO',
}

export interface UserContent {
  email?: string;
  caid?: string;
  signature?: string;
  firstName?: string;
  lastName?: string;
  expiration?: string;
  // support
  user?: string;
  support?: string;
  role?: string;
  hash?: string;
}

export interface UserReducerAction {
  type: UserReducerActionType;
  payload: UserContent;
}

export const userReducer = (state: UserContent, action: UserReducerAction): UserContent => {
  switch(action.type) {
    case UserReducerActionType.UPDATE_USER_INFO:
      return { ...state, ...action.payload };
    case UserReducerActionType.CLEAR_USER_INFO:
      return {};
    default:
      return state;
  }
};
